import React, { useEffect, useState } from "react";
import { useStateValue } from "../../../../stateprovider"
import "./summaryready.css";
import { useNavigate } from "react-router-dom";

const SummaryComp = () => {
    const [{ }, dispatch] = useStateValue();
    const navigate = useNavigate();
    const [recordInfoState, setRecordInfoState] = useState(false);

    useEffect(() => {
        dispatch({
            type: "APP_NAV_STATE",
            appnav: false
        });
   
    }, []);

    const summaryArray = [
        {
            title: "Ampicilline DMP", dosage: "8 hours from ..."
        },
        {
            title: "Dopatrix", dosage: "8 hours from ..."
        },

    ]
  

    return <div className="app_complaint app_extend">
        <div className="app_record_container">
            <div className="app_record_top">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" 
                onClick={()=> {
                    if(recordInfoState){
                        setRecordInfoState(false);
                    }else{
                        navigate(-1)
                    }
                    
                }} style={{cursor: "pointer"}}>

                    <path d="M15 18L9 12L15 6" stroke="#0F0F0F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <h4>
                    summary note
                </h4>
            </div>
      
                <div className="app_summary_container">
                    <h6>This week</h6>

                    <div className="app_summary_note">
                        <p>vitamin c</p>

                        <p>
                        Take long walk to exercise the body. 
                        Also I recommend you take 25 cups of water in a day to keep you hyrdrated always. Go to the cinema to watch some funny movies.Also I recommend you take 25 cups of water in a day to keep you hyrdrated always. Go to the cinema to watch some funny movies.
                        </p>
                        <p>Dosage : Two pills daily </p>
                    </div>
                    <div className="app_summary_note_footer">
                    {
                        summaryArray.map((summary, index)=>{
                            return  <div className="app_summary_col" key={index}>
                            <p>{summary.title}</p>

                            <small>Dosage</small>

                            <p>{summary.dosage}</p>
                        </div>
                        })
                    }
            
                    </div>
                </div>
        </div>
    </div>
}
export default SummaryComp;